import { SIGNATURE_BATCH_SIZE } from '../BorerShiftSignature/queryBuilder';
import { EmployeeDocument } from '../Employees/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  SignatureDocument,
  signaturePullQueryBuilder,
  signaturePushQueryBuilder,
} from './rxdbSignatureDefinition';

export function signaturesFamilyMember(
  configBuilder: ConfigBuilder,
  employees: FamilyMember<EmployeeDocument>,
): FamilyMember<SignatureDocument> {
  const syncConfig = configBuilder<SignatureDocument>(RxdbCollectionNameV2.SIGNATURES);
  doNotAutoSync(syncConfig);

  const pullConfig = pull(syncConfig, signaturePullQueryBuilder);
  pullConfig.batchSize = SIGNATURE_BATCH_SIZE;

  push(syncConfig, signaturePushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.SIGNATURES, replicationState, [employees]);
}
